


import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import MapObject from '@/interfaces/entities/map-object.interface';
import TranslationsService from '@/services/translations.service';
import ApiService from '@/services/api.service';
import Destination from '@/interfaces/api/destination.interface';
import MapFeaturesService from '@/services/map-features.service';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import AppMapObjectActions from '../map-object-actions/map-object-actions.vue';
import ObjectReportService from '@/services/object-report.service';
import {CustomObservable} from '@/library/observable/custom-observable';

declare const MiniSlider: any;
declare const jQuery: any;

@Component({})
export default class AppMapObject extends Vue {

  @Prop()
  public object!: MapObject;

  @Emit('close')
  public emitClose(): MapObject {
    return this.object;
  }

  @Watch('object', {immediate: false})
  public objectChange(): void {
    this.initObject();
  }

  public isPreview: boolean = true;
  private mapObjectActionsRef: AppMapObjectActions | null = null;
  private miniSliderInitialized: boolean = false;
  private api: ApiService = ApiService.getInstance();
  private translations: TranslationsService = TranslationsService.getInstance();
  private mapFeaturesService: MapFeaturesService = MapFeaturesService.getInstance();
  private objectReportService: ObjectReportService = ObjectReportService.getInstance();

  constructor() {
    super();
  }

  public mounted(): void {
    this.mapObjectActionsRef = this.$refs.objectActions as AppMapObjectActions;
    this.initObject();
  }

  public close(): void {
    this.emitClose();
  }

  public report(): string {
    let params = new URLSearchParams({
      'subject': this.translations.translation('COM_MAMMADABA_MAP_REPORT_SUBJECT') + ' ' + this.object.id
    });
    if (this.translations.translation('COM_MAMMADABA_MAP_REPORT_CC') !== '') {
      params.append('cc', this.translations.translation('COM_MAMMADABA_MAP_REPORT_CC'))
    }
    return this.translations.translation('COM_MAMMADABA_MAP_REPORT_TO') + '?' + params.toString().replace(/\+/g, ' ');
  }

  public openReportForm(): void {
    this.objectReportService.openForm();
  }

  public toggleVisited(): void {
    if (this.object) {
      this.object.visited = !this.object.visited;
      this.api.toggleVisited(this.object.id, this.object.visited);
    }
  }

  public get numberOfImages(): number {
    return this.object.images ? this.object.images.length : 0;
  }

  public isVisitedAvailable(): boolean {
    return this.api.user().isAuthenticated
        && this.mapFeaturesService.isFeatureInFeaturesList(this.object.mapFeature.getId());
  }

  public isObjectActionsAvailable(): boolean {
    return !!this.mapObjectActionsRef && this.mapObjectActionsRef.isAnyButtonAvailable();
  }

  private initObject(): void {
    const observable: Observable<void | null> = this.object.images ? CustomObservable.empty() : this.fetchImages();
    observable.subscribe(() => {
      this.miniSliderInitialized = false;
      this.initMiniSlider();
    });
  }

  private initMiniSlider(): void {
    if (document.readyState === 'complete') {
      Vue.nextTick(() => {
        if (!this.miniSliderInitialized) {
          this.miniSliderInitialized = true;
          (new MiniSlider(jQuery('.map-object-container'))).run();
        }
      });
    } else {
      window.onload = () => {
        this.initMiniSlider();
      }
    }
  }

  private fetchImages(): Observable<void> {
    return this.mapFeaturesService.mapObjectImages(this.object).pipe(
        map(images => {
          this.object.images = images;
        })
    );
  }

  private objectPageUrl(): string {
    const object = this.api.destinations().find((destination: Destination) => {
      return destination.lvm_geo_id.toString() === this.object.id;
    });
    return object ? object.url : '';
  }

  private imageClass(index: number, numberOfImages: number): string {
    let cssClass: string = '';
    if (index === 0) {
      cssClass = 'active';
    } else if (index === 1) {
      cssClass = 'next';
    } else if (numberOfImages - 1 === index) {
      cssClass = 'previous';
    }
    return cssClass;
  }
}
